import React, { useState } from 'react';
import styled from 'styled-components';
import updateStoreSettings from '../utils/updateStoreSettings';

const Container = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: #C41E3A;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #A01930;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Message = styled.div`
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 4px;
  
  &.success {
    background-color: #d1e7dd;
    color: #0f5132;
  }
  
  &.error {
    background-color: rgba(196, 30, 58, 0.1);
    color: #C41E3A;
  }
`;

const UpdateSettings = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  
  const handleUpdateSettings = async () => {
    setLoading(true);
    try {
      const success = await updateStoreSettings();
      if (success) {
        setResult({
          type: 'success',
          message: 'Store settings updated successfully! Your shipping address has been updated.'
        });
      } else {
        setResult({
          type: 'error',
          message: 'Failed to update store settings.'
        });
      }
    } catch (error) {
      console.error('Error updating settings:', error);
      setResult({
        type: 'error',
        message: `Error updating settings: ${error.message}`
      });
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Container>
      <h1>Update Store Settings</h1>
      <p>Click the button below to update your store settings with the correct shipping address information.</p>
      
      <Button onClick={handleUpdateSettings} disabled={loading}>
        {loading ? 'Updating...' : 'Update Store Settings'}
      </Button>
      
      {result && (
        <Message className={result.type}>
          {result.message}
        </Message>
      )}
      
      <div style={{ marginTop: '2rem' }}>
        <h2>New Address Information</h2>
        <pre style={{ background: '#f5f5f5', padding: '1rem', borderRadius: '4px' }}>
          {`
Name: Master Collectors Forge
Street: 632 Fredrico Blvd
City: Belen
State: NM
ZIP: 87002
Country: US
Phone: 505-363-6058
Email: info@mastercollectorsforge.com
          `}
        </pre>
      </div>
    </Container>
  );
};

export default UpdateSettings;
